export default "__VITE_ASSET__BP1fIk38__"